export const VITE_ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT as string;

export const VITE_LEGACY_API = import.meta.env.VITE_LEGACY_API as string;
export const VITE_GATEWAY_API = import.meta.env.VITE_GATEWAY_API as string;
export const VITE_MARKET_API = import.meta.env.VITE_MARKET_API as string;
export const VITE_COMPANY_API = import.meta.env.VITE_COMPANY_API as string;
export const VITE_CLOUD_API = import.meta.env.VITE_CLOUD_API as string;
export const VITE_TOOLS_API = import.meta.env.VITE_TOOLS_API as string;

export const VITE_SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN as string;

export const VITE_OKTA_CALLBACK_URL = import.meta.env
  .VITE_OKTA_CALLBACK_URL as string;
export const VITE_OKTA_ISSUER = import.meta.env.VITE_OKTA_ISSUER as string;
export const VITE_OKTA_CID = import.meta.env.VITE_OKTA_CID as string;
export const VITE_OKTA_API = import.meta.env.VITE_OKTA_API as string;

export const VITE_TRADIER_CID = import.meta.env.VITE_TRADIER_CID as string;

export const VITE_GA_MEASUREMENT_ID = import.meta.env
  .VITE_GA_MEASUREMENT_ID as string;
